module.exports = __webpack_public_path__ + "img/100.60384dd8.jpg";